import { Box, Button, Dialog, DialogActions, DialogTitle } from '@mui/material'
import { LogEntry } from '../../api/DTO'
import { LogTable } from '../../controls/specifics/logs/LogTable'

type LogDialogProps = {
	open: boolean
	logTitle: string
	logEntries: LogEntry[]
	onClose: () => void
}

export const LogDialog = (props: LogDialogProps) => {
	return (
		<Dialog open={props.open} maxWidth="lg">
			<Box
				component={DialogTitle}
				display="flex"
				justifyContent="space-between"
				alignItems="center"
			>
				{props.logTitle}
			</Box>
			<LogTable
				entries={props.logEntries}
				editorHeight="50vh"
				editorWidth="100vh"
				maxTableHeight="60vh"
			/>
			<DialogActions>
				<Button variant="outlined" onClick={props.onClose}>
					Close
				</Button>
			</DialogActions>
		</Dialog>
	)
}
